import { useState } from "react";
import { changePasswordRequest, checkPasswordRequest } from "../../services/APIService";

interface Errors {
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

interface Props {
  tag: string;
  onClose?: () => void;
}

export const useChangePasswordVM = ({ tag, onClose }: Props) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState<Errors>({});
  const [passwordState, setPasswordState] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const validate = async (): Promise<boolean> => {
    const newErrors: Errors = {};

    if (!oldPassword) newErrors.oldPassword = "Bitte altes Passwort eingeben";
    else {
      const exists = await checkPasswordRequest(tag, oldPassword);
      if (!exists) newErrors.oldPassword = "Altes Passwort falsch";
    }

    if (!newPassword) newErrors.newPassword = "Bitte neues Passwort eingeben";
    else if (newPassword.length < 8) newErrors.newPassword = "Mindestens 8 Zeichen";

    if (!confirmPassword) newErrors.confirmPassword = "Bitte neues Passwort bestätigen";
    else if (newPassword !== confirmPassword) newErrors.confirmPassword = "Passwörter stimmen nicht überein";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePasswordChange = async () => {
    if (await validate()) {
      const result = await changePasswordRequest(tag, newPassword);
      setPasswordState(
        result
          ? "Passwort wurde erfolgreich geändert"
          : "Passwort konnte nicht geändert werden, bitte später versuchen."
      );
      setShowPopup(true);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    onClose?.();
  };

  return {
    state: {
      oldPassword,
      newPassword,
      confirmPassword,
      errors,
      passwordState,
      showPopup,
      oldPasswordVisible,
      newPasswordVisible,
      confirmPasswordVisible,
    },
    actions: {
      setOldPassword,
      setNewPassword,
      setConfirmPassword,
      toggleOldPasswordVisible: () => setOldPasswordVisible(prev => !prev),
      toggleNewPasswordVisible: () => setNewPasswordVisible(prev => !prev),
      toggleConfirmPasswordVisible: () => setConfirmPasswordVisible(prev => !prev),
      handlePasswordChange,
      handleClosePopup,
    },
  };
};